import React from 'react';
import { UserProfile } from '@/shared/types';

interface SidebarProps {
  profile: UserProfile;
  type: string;
  metaData: { label: string; value: string }[];
  config: any;
  LogoImage: React.FC<{ size: 'sm' | 'md' | 'lg' | 'xl'; className?: string; light?: boolean }>;
}

export const SidebarLeftComponent: React.FC<SidebarProps> = ({ profile, type, metaData, config, LogoImage }) => (
  <div className={`w-1/3 p-12 flex flex-col justify-between ${config.header === 'dark-sidebar' ? 'bg-[#1e293b] text-white' : 'bg-gray-100 text-gray-800'}`}>
    <div>
      <LogoImage size="lg" light={config.header === 'dark-sidebar'} className="mb-8"/>
      <h1 className="text-3xl font-bold uppercase tracking-tight leading-none mb-4">{profile.name}</h1>
      <div className="text-sm space-y-1 opacity-80">
        <p>{profile.address}</p>
        <p>{profile.email}</p>
        <p>{profile.phone}</p>
      </div>
    </div>

    <div className="space-y-6">
      <div className="pt-8 border-t border-white/20">
        <h2 className="text-4xl font-black uppercase tracking-tighter opacity-50 mb-4">{type}</h2>
        <div className="space-y-2">
          {metaData.map(m => (
            <div key={m.label} className="flex justify-between text-sm">
              <span className="opacity-60 uppercase text-xs pt-0.5">{m.label}</span>
              <span className="font-bold">{m.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export const SidebarRightComponent: React.FC<SidebarProps> = ({ profile, type, metaData, LogoImage }) => (
  <div className="w-1/3 bg-gray-50 border-l border-gray-200 p-12 flex flex-col text-right">
    <LogoImage size="lg" className="self-end mb-8"/>
    <h1 className="text-3xl font-bold uppercase tracking-tight text-gray-900 mb-4">{profile.name}</h1>
    <div className="text-sm text-gray-500 space-y-1 mb-12">
      <p>{profile.address}</p>
      <p>{profile.email}</p>
      <p>{profile.phone}</p>
    </div>
    <div className="mt-auto">
      <h2 className="text-4xl font-light text-primary-600 mb-6">{type}</h2>
      {metaData.map(m => (
        <div key={m.label} className="mb-4">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-wider">{m.label}</p>
          <p className="text-lg font-bold text-gray-900">{m.value}</p>
        </div>
      ))}
    </div>
  </div>
);